import axiosInstance from "../../api/axiosInstance";

export const fetchPaginatedUsersAPI = async (page, limit) => {
  const usersList = await axiosInstance.get(
    `users/get-paginated-users?page=${page}&limit=${limit}`
  );

  return usersList.data;
};

export const deleteUserAPI = async (id) => {
  const deletedUser = await axiosInstance.delete(`users/delete-user/${id}`);

  return deletedUser.data;
};

export const updateUserAPI = async (id, userData) => {
  const updatedUser = await axiosInstance.put(
    `users/update-user/${id}`,
    userData
  );

  return updatedUser.data;
};

